export enum CompensationTrigger {
  'None' = 0,
  'Application Submitted' = 1,
  'Application Completed' = 2,
  'Policy Issued' = 3,
  'Description Provided' = 4,
  'Appraisal Completed' = 5
}
